/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { Fragment } from "react";

import { spacing } from "../../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";
import type { BlockProps } from "../../../../refactor/Block/Block.emotion";
import { Block } from "../../../../refactor/Block/Block.emotion";
import type { ContentMediumProps } from "../ContentMedium/ContentMedium.emotion";
import { ContentMedium } from "../ContentMedium/ContentMedium.emotion";

const actionsStyle: Interpolation = {
  marginTop: spacing.m,
};
const blockStyle: Interpolation = {
  display: "none",
  [cssMediaQueryMinWidthTablet]: { display: "flex" },
};
const contentMediumStyle: Interpolation = {
  display: "flex",
  [cssMediaQueryMinWidthTablet]: { display: "none" },
};

export type ContentLargeProps = Pick<
  ContentMediumProps,
  | "asChild"
  | "children"
  | "activeState"
  | "color"
  | "description"
  | "focusState"
  | "hoverState"
  | "imgSrc"
  | "metadata"
  | "metadataInlineIcon"
  | "subscription"
  | "title"
> &
  Pick<BlockProps, "actions" | "color">;

export const ContentLarge = ({
  actions,
  activeState = false,
  asChild,
  children,
  color,
  description,
  focusState = true,
  hoverState = true,
  imgSrc,
  metadata,
  metadataInlineIcon,
  subscription,
  title,
}: ContentLargeProps) => {
  return (
    <Fragment>
      <Block
        actions={actions}
        actionsCSS={actionsStyle}
        activeState={activeState}
        color={color}
        description={description}
        focusState={focusState}
        hoverState={hoverState}
        imgSrc={imgSrc}
        metadata={metadata}
        metadataInlineIcon={metadataInlineIcon}
        css={blockStyle}
        subscription={subscription}
        title={title}
      />
      <ContentMedium
        activeState={activeState}
        asChild={asChild}
        children={children}
        description={description}
        focusState={focusState}
        hoverState={hoverState}
        imgSrc={imgSrc}
        metadata={metadata}
        metadataInlineIcon={metadataInlineIcon}
        css={contentMediumStyle}
        subscription={subscription}
        title={title}
      />
    </Fragment>
  );
};
